import React from "react";
import CorporateHeader from "./CorporateHeader";

/**
 * Minimal corp-branded shell shown while a Corporate page is fetching its
 * branding/content. Renders the same header + grey backdrop + footer chrome
 * as the eventual page so navigating between Activation → Setup → Done
 * transitions smoothly instead of flashing a white screen.
 *
 * Branding is optional — if not yet loaded, the header shows just the Aris
 * logo with the "Loading…" placeholder name.
 */
const CorporateLoadingShell = ({ branding, themeStyle }) => (
  <div
    className="corp-activation min-h-screen flex flex-col"
    style={themeStyle}
  >
    <CorporateHeader branding={branding} />
    <main className="flex-1 flex items-center justify-center px-4">
      <div
        aria-label="Loading"
        role="status"
        className="size-9 rounded-full border-4 border-[#e4e4e7] border-t-[var(--corporate-secondary,#0d5eaf)] animate-spin"
      />
    </main>
  </div>
);

export default CorporateLoadingShell;
